// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"1795bf43","484":"1ab3ac05","869":"690a8d66","974":"2ea8dc15"}[chunkId] + ".chunk.js";
};